import { Component } from '@angular/core';

@Component({
  selector: 'app-not-authenticated',
  template: `
    <div class="text-center">
      <h1 class="text-2xl font-bold mb-4">Sessione scaduta</h1>
      <p class="text-gray-500">
        Per favore, effettua nuovamente l'accesso da HubSpot.
      </p>
    </div>
  `,
  host: {
    class: 'h-full flex items-center justify-center',
  },
})
export class NotAuthenticatedComponent {}
